import { ENGLISH_IQ_LANDING_IMG_SLUG } from './english-iq';

export const CEFR_SLUGS = ['a1', 'a2', 'b1', 'b2', 'c1', 'c2'] as const;

export const NATIVE_SLUGS = [
  'mandarin-chinese',
  'hindi',
  'spanish',
  'french',
  'arabic',
  'bengali',
  'portuguese',
  'russian',
  'urdu',
  'german',
  'persian',
  'italian',
] as const;

export const COMPARE_SLUGS = ['anki', 'babbel', 'duolingo', 'memrise', 'rosetta-stone'] as const;

export const PAGE_SLUGS = [
  'home',
  'pricing',
  'watch',
  'compare',
  'about',
  'story',
  'mission',
  'values',
  'vision',
  'changelog',
  'faq',
  'help',
  'contact',
  'app',
  'roadmap',
  'login',
  'brand',
  'press',
  'logo',
  'status',
  'privacy',
  'terms',
  'cookies',
  'dmca',
  'accessibility',
  'delete-account',
  'social-responsibility',
  'challenge-hub',
  'collection-hub',
  ENGLISH_IQ_LANDING_IMG_SLUG,
] as const;
